import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'
import VehicleBookingListTable from './Components/VehicleBookingListTable'

const VehicleBookingList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Vehicle Booking List</HeadingOne>
                </>
            }>

            <div className="col-12">
                <VehicleBookingListTable />
            </div>
        </PageBody>
    )
}

export default VehicleBookingList
